/* Goldtop custom size finder — assets/sh-size-finder.js
 * Loaded once site-wide. A trigger with [data-shsf-open] opens a modal
 * configured from its data-product-name / data-fit attributes.
 * Chart is shared across all jackets; fit profile is per-product (default medium-slim).
 * Two-step flow: (1) measure -> confirm, (2) result + email capture + size pre-select. */
(function(){
  if(window.__shsfLoaded) return; window.__shsfLoaded=true;

  // ---- analytics: GA4 event + Google Sheet beacon ----
  var SHSF_ENDPOINT='https://script.google.com/macros/s/AKfycbwtyfqK6WIHfrZrwpcywQRWVW3ohuKLuyTXYNHGPGGg1X1rgLhBvHc1_Y3q3gn5dBmj/exec';
  function shsfId(store,key){
    try{var v=store.getItem(key);if(!v){v=Date.now().toString(36)+Math.random().toString(36).slice(2,10);store.setItem(key,v);}return v;}catch(e){return '';}
  }
  function browserEnv(){
    var dev='';try{dev=/Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent)?'mobile':'desktop';}catch(e){}
    var tz='';try{tz=Intl.DateTimeFormat().resolvedOptions().timeZone;}catch(e){}
    return {page:location.pathname,referrer:document.referrer||'',device:dev,
      viewport:(window.innerWidth||'')+'x'+(window.innerHeight||''),
      language:navigator.language||'',timezone:tz};
  }
  function track(evt,info){
    info=info||{};
    var visitor='',session='',k;
    try{visitor=shsfId(window.localStorage,'shsf_vid');}catch(e){}
    try{session=shsfId(window.sessionStorage,'shsf_sid');}catch(e){}
    var payload={event:evt};
    for(k in info){if(info[k]!==undefined&&info[k]!==null)payload[k]=info[k];}
    payload.visitor=visitor;payload.session=session;
    var env=browserEnv();for(k in env){payload[k]=env[k];}
    try{if(window.gtag){window.gtag('event',evt,payload);}
        else if(window.dataLayer&&window.dataLayer.push){window.dataLayer.push(payload);}}catch(e){}
    try{
      var qs=[],pk;for(pk in payload){qs.push(encodeURIComponent(pk)+'='+encodeURIComponent(payload[pk]));}
      var url=SHSF_ENDPOINT+'?'+qs.join('&');
      try{var img=new Image();img.src=url;}          // pixel GET: survives Apps Script's redirect
      catch(e2){fetch(url,{mode:'no-cors',keepalive:true});}
    }catch(e){}
  }
  // Email capture goes by POST (keeps the address out of the URL/query string).
  function capturePost(info){
    try{
      var visitor='',session='',k;
      try{visitor=shsfId(window.localStorage,'shsf_vid');}catch(e){}
      try{session=shsfId(window.sessionStorage,'shsf_sid');}catch(e){}
      var payload={}; for(k in info){if(info[k]!==undefined&&info[k]!==null)payload[k]=info[k];}
      payload.event='size_finder_capture'; payload.visitor=visitor; payload.session=session;
      var env=browserEnv(); for(k in env){payload[k]=env[k];}
      try{if(window.gtag){window.gtag('event','size_finder_capture',{size_chosen:payload.size_chosen,consent:payload.consent});}}catch(e){}
      fetch(SHSF_ENDPOINT,{method:'POST',body:JSON.stringify(payload),mode:'no-cors',keepalive:true});
    }catch(e){}
  }
  function prodInfo(){
    return {product:cfg?cfg.name:'',product_handle:cfg?cfg.handle:'',product_price:cfg?cfg.price:'',
      customer_email:cfg?cfg.email:'',customer_id:cfg?cfg.cid:''};
  }
  function resultInfo(){
    var r=recommend(),info=prodInfo();
    info.chest_in=Math.round(state.chestIn*10)/10;
    info.waist_in=Math.round(state.waistIn*10)/10;
    info.height_in=Math.round(state.heightIn*10)/10;
    info.chest_unit=state.chestUnit;info.waist_unit=state.waistUnit;info.height_unit=state.heightUnit;
    info.fit=state.fit;
    info.suggested_size=r.talk?'out_of_range':r.size;
    info.out_of_range=!!r.talk;
    var sset=sizeSet();
    info.size_snug =sset.out?'out_of_range':sset.snug;
    info.size_true =sset.out?'out_of_range':sset.tru;
    info.size_roomy=sset.out?'out_of_range':sset.roomy;
    info.duration_sec=Math.round((Date.now()-(state.openedAt||Date.now()))/1000);
    info.adjustments=state.adjustments||0;
    info.unit_switches=state.unitSwitches||0;
    info.fit_switches=state.fitSwitches||0;
    info.sizes_previewed=state.sizesPreviewed||0;
    info.hit_out_of_range=!!state.everOOR;
    info.edits=state.edits||0;
    return info;
  }
  // Single source of truth for sizing (used by recommend + sizeSet). Refined from measured-fit data:
  // TRUE is chest-anchored (accurate baseline); jackets run slightly small so ROOMY = next size and
  // barrel builds (waist >= chest) headline to it; SNUG only when there's real room to size down.
  function trueIdxFor(c,w){
    var cand=CHART.filter(function(r){return c>=r.cmin&&c<=r.cmax;});
    if(!cand.length) cand=[rowForChest(c)];
    var tr=null;
    for(var i=0;i<cand.length;i++){ if(w<=cand[i].wmax){ tr=cand[i]; break; } }
    if(!tr) tr=cand[cand.length-1];
    return CHART.indexOf(tr);
  }
  function sizing(){
    var c=state.chestIn,w=state.waistIn,h=state.heightIn;
    if(c<C_MIN||c>C_MAX) return {out:true,why:'chest'};
    if(w<W_MIN||w>W_MAX) return {out:true,why:'waist'};
    if(h<H_MIN)          return {out:true,why:'short'};
    var ci=trueIdxFor(c,w);                                          // chest-anchored index
    var ti=ci; while(ti<CHART.length-1 && w>CHART[ti].wmax+3) ti++;  // climb until the waist can close (~3" give)
    var tr=CHART[ti];
    if(h>=H_TALL_HARD)                          return {out:true,why:'tall'};
    if(h>=H_TALL_SOFT && tr.size<TALL_MIN_SIZE) return {out:true,why:'tall-girth'};
    var snug=(ti>0 && c<=CHART[ti-1].cmax-1)?CHART[ti-1]:null;        // closer cut, only if the chest still fits it
    var roomy=(ti<CHART.length-1 && (ti+1)<=(ci+2))?CHART[ti+1]:null; // one up, capped so the chest doesn't swim
    var belly=(w>=c) && !!roomy;
    var hnote = h>tr.hmax ? 'tall' : (h<tr.hmin ? 'short' : '');
    return {out:false, ti:ti, tr:tr, snug:snug, roomy:roomy, belly:belly, hnote:hnote};
  }
  function sizeSet(){
    var s=sizing();
    if(s.out) return {out:true};
    return { out:false, snug:(s.snug?s.snug.size:s.tr.size), tru:s.tr.size, roomy:(s.roomy?s.roomy.size:s.tr.size) };
  }
  // size the customer has settled on (previewed neighbour wins, else the fit suggestion)
  function chosenSizeNow(){ var r=recommend(); if(r.talk) return ''; return viewSize||r.size; }
  // remember the chosen size on the device so PDPs/collection can offer it without a login
  function rememberSize(sz){ try{ if(sz) window.localStorage.setItem('shsf_size', String(sz)); }catch(e){} }
  function stampCart(info,chosen){
    try{
      var v=''; try{v=shsfId(window.localStorage,'shsf_vid');}catch(e){}
      var hi=Math.round(Number(info.height_in)||0);
      var meas='Chest '+(info.chest_in||'')+'" · Waist '+(info.waist_in||'')+'" · Height '+Math.floor(hi/12)+"'"+(hi%12)+'"';
      var attrs={
        '_Measurements':meas,
        '_Snug':(info.size_snug||''),
        '_True':(info.size_true||''),
        '_Roomy':(info.size_roomy||''),
        '_Chosen':(chosen||''),
        '_Visitor':v
      };
      fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:attrs})});
    }catch(e){}
  }
  // Pre-select the chosen size on the product page's variant picker (Impulse radios/selects).
  function preselectSize(size){
    if(!size) return;
    var want=parseFloat(String(size));
    if(isNaN(want)) return;
    function num(val){ var s=String(val); if(!/^\s*\d/.test(s)) return NaN; return parseFloat(s.replace(/[^0-9.].*$/,'')); }
    var hit=null;
    document.querySelectorAll('.variant-input-wrap input[type=radio], form[action*="/cart/add"] input[type=radio]').forEach(function(inp){
      if(hit) return; if(num(inp.value)===want) hit=inp;
    });
    if(hit){
      if(!hit.checked){
        hit.checked=true;
        hit.dispatchEvent(new Event('change',{bubbles:true}));
        hit.dispatchEvent(new Event('click',{bubbles:true}));
      }
      var lab=document.querySelector('label[for="'+(hit.id||'')+'"]'); if(lab) lab.classList.add('selected');
      return;
    }
    document.querySelectorAll('.variant-input-wrap select, form[action*="/cart/add"] select').forEach(function(sel){
      if(hit) return;
      for(var i=0;i<sel.options.length;i++){ if(num(sel.options[i].value)===want){ sel.selectedIndex=i; sel.dispatchEvent(new Event('change',{bubbles:true})); hit=sel; break; } }
    });
  }


  // ---- shared Goldtop jacket chart (chest/waist/height in inches) ----
  // 44" waist band interpolated (obscured in source chart) as 38–40.
  var CHART=[
    {size:36,cmin:34,cmax:36,wmin:26,wmax:29.5,hmin:62,hmax:67,sleeve:"22–23.5"},
    {size:38,cmin:36,cmax:38,wmin:29,wmax:32,  hmin:65,hmax:69,sleeve:"23–24"},
    {size:40,cmin:38,cmax:40,wmin:31,wmax:34,  hmin:66,hmax:71,sleeve:"23.5–24.5"},
    {size:42,cmin:40,cmax:42,wmin:33,wmax:38,  hmin:67,hmax:72,sleeve:"24–25"},
    {size:44,cmin:42,cmax:44,wmin:38,wmax:40,  hmin:68,hmax:74,sleeve:"24.5–26"},
    {size:46,cmin:43,cmax:46,wmin:40,wmax:45,  hmin:69,hmax:75,sleeve:"25–26"},
    {size:48,cmin:46,cmax:48,wmin:44,wmax:48,  hmin:69,hmax:75,sleeve:"25.5–27"},
    {size:50,cmin:47,cmax:50,wmin:47,wmax:50,  hmin:69,hmax:75,sleeve:"25.5–27"},
    {size:52,cmin:49,cmax:52,wmin:48,wmax:52,  hmin:69,hmax:75,sleeve:"25.5–27"}
  ];
  var C_MIN=34,C_MAX=52,W_MIN=26,W_MAX=52,H_MIN=62,H_MAX=75;
  // Height gates (sleeves are NOT adjustable): 6'6"+ (78") never fits; 6'5" (77") only if the girth
  // is a 48+; 6'4" (76") still gets a size, with a note that the length may sit a little short.
  var H_TALL_SOFT=77,H_TALL_HARD=78,TALL_MIN_SIZE=48;

  function clamp(v,a,b){return Math.max(a,Math.min(b,v));}
  function rowForChest(c){return CHART.find(function(r){return r.cmax>=c;})||CHART[CHART.length-1];}
  function rowForWaist(w){return CHART.find(function(r){return r.wmax>=w;})||CHART[CHART.length-1];}

  var root=null,state=null,cfg=null,viewSize=null;
  function q(s){return root.querySelector(s);}

  function recommend(){
    var c=state.chestIn,w=state.waistIn,fit=state.fit;
    var cR=Math.round(c*10)/10,wR=Math.round(w*10)/10;
    var fitWord=cfg.fit;
    var s=sizing();
    if(s.out){
      var main, sub="Leave your email and we can help with your fit, including made-to-measure.";
      if(s.why==='tall')
        main="Your height is beyond what our jackets are cut for — the sleeves would come up short, and we'd sooner get this right than guess.";
      else if(s.why==='tall-girth')
        main="At your height, only our larger jackets have the length — and your chest and waist sit below those, so we'd rather not leave you with short sleeves.";
      else if(s.why==='short')
        main="Your height sits below our standard jacket sizing, so we'd sooner get this right than guess.";
      else
        main="Your "+(s.why==='chest'?"chest":"waist")+" sits beyond our standard jacket sizing, so we'd sooner get this right than guess.";
      return {talk:true, main:main, sub:sub};
    }
    var pick, main;
    if(fit==='snug'){
      if(s.snug){ pick=s.snug; main="A closer cut — <b>"+pick.size+"″</b> sits snug, eases with wear."; }
      else { pick=s.tr; main="<b>"+pick.size+"″</b> is as close as we'd go — anything smaller pulls across the chest."; }
    } else if(fit==='layer'){
      if(s.roomy){ pick=s.roomy; main="Room to layer — <b>"+pick.size+"″</b>, easy over a jumper."; }
      else { pick=s.tr; main="<b>"+pick.size+"″</b> is the roomiest we make."; }
    } else {
      if(s.belly){ pick=s.roomy; main="<b>"+pick.size+"″</b> — you carry a little through the middle, so this sits better than a "+s.tr.size+"″."; }
      else { pick=s.tr; main=(fitWord?("Runs "+fitWord+", true to size"):("True to size"))+" — your "+cR+"″ chest and "+wR+"″ waist sit here."; }
    }
    var sub="";
    if(s.hnote==='tall') sub="<span style='color:#9d988c'>Heads up — at your height the length (body and sleeves) may sit a little short.</span>";
    else if(s.hnote==='short') sub="<span style='color:#9d988c'>You're on the short side for this size — it may sit a touch long.</span>";
    var detail="Fits chest "+pick.cmin+"–"+pick.cmax+"″ · waist "+pick.wmin+"–"+pick.wmax+"″ · sleeve "+pick.sleeve+"″";
    return {size:pick.size,detail:detail,main:main,sub:sub};
  }

  function computeBar(v,lo,hi){
    var pad=Math.max(2,hi-lo),sLo=lo-pad,sHi=hi+pad;
    var x=clamp((v-sLo)/(sHi-sLo),0,1);
    var leftPct=clamp((1-x)*100,3,97);
    var xLo=(lo-sLo)/(sHi-sLo),xHi=(hi-sLo)/(sHi-sLo);
    return {leftPct:leftPct,gLeft:(1-xHi)*100,gWidth:(xHi-xLo)*100,inRange:(v>=lo&&v<=hi)};
  }

  function renderExtras(recSize){
    var display=viewSize||recSize;
    var row=CHART.find(function(r){return r.size===display;});
    var dims=[
      {name:"Chest",v:state.chestIn,lo:row.cmin,hi:row.cmax,L:"Snug",R:"Roomy"},
      {name:"Waist",v:state.waistIn,lo:row.wmin,hi:row.wmax,L:"Snug",R:"Roomy"},
      {name:"Length",v:state.heightIn,lo:row.hmin,hi:row.hmax,L:"Short",R:"Long"}
    ];
    var bars="";
    dims.forEach(function(d){
      var b=computeBar(d.v,d.lo,d.hi);
      bars+='<div class="shsf-fitbar"><span class="shsf-fbname">'+d.name+'</span>'
        +'<div class="shsf-fbtrack"><div class="shsf-fbgreen'+(b.inRange?'':' out')+'" style="left:'+b.gLeft+'%;width:'+b.gWidth+'%"></div>'
        +'<div class="shsf-fbmark" style="left:'+b.leftPct+'%"></div></div>'
        +'<div class="shsf-fbends"><span>'+d.L+'</span><span>'+d.R+'</span></div></div>';
    });
    q('.shsf-fitbars').innerHTML=bars;
    var recIdx=CHART.findIndex(function(r){return r.size===recSize;}),chips="";
    [recIdx-1,recIdx,recIdx+1].forEach(function(i){
      if(i<0||i>=CHART.length)return; var s=CHART[i].size;
      chips+='<button class="shsf-nb'+(s===display?' current':'')+'" data-size="'+s+'">'+s+'″'+(s===recSize?'<i>suggested</i>':'')+'</button>';
    });
    var nb=q('.shsf-neighbours'); nb.innerHTML=chips;
    nb.querySelectorAll('.shsf-nb').forEach(function(btn){
      btn.addEventListener('click',function(){viewSize=parseInt(this.getAttribute('data-size'));render(true);});
    });
  }

  function render(preserve){
    if(!preserve) viewSize=null;
    if(state && state.step>=2){
      var r=recommend();
      if(r.talk)state.everOOR=true;
      var card=q('.shsf-result'),sizeEl=q('.shsf-rsize'),mainEl=q('.shsf-rmain'),panel=q('.shsf-fitpanel');
      if(r.talk){
        card.classList.add('talk'); q('.shsf-rlabel').style.display='none'; sizeEl.style.display='none';
        q('.shsf-rdetail').textContent=""; mainEl.className='shsf-rmain talk'; panel.style.display='none';
        mainEl.innerHTML=r.main; mainEl.style.display='';
      } else {
        card.classList.remove('talk'); q('.shsf-rlabel').style.display=''; sizeEl.style.display='';
        sizeEl.innerHTML=r.size+"<span>″</span>"; q('.shsf-rdetail').textContent=r.detail;
        mainEl.className='shsf-rmain'; panel.style.display=''; renderExtras(r.size);
        mainEl.innerHTML=''; mainEl.style.display='none';
      }
      q('.shsf-rsub').innerHTML=r.sub||"";
      var toshop=q('.shsf-toshop'),cap=q('.shsf-capture'),lead=q('.shsf-caplead');
      if(r.talk){
        if(toshop) toshop.style.display='none';
        if(cap) cap.style.display='';
        if(lead) lead.textContent='Leave your email and we can help with your fit, including made-to-measure.';
      } else {
        if(cap) cap.style.display='none';
        if(toshop){ toshop.style.display=''; var cs=viewSize||r.size; toshop.textContent='Shop '+cs+'″'; }
      }
    }
    if(state.chestUnit==='in'){q('.shsf-cval').textContent=Math.round(state.chestIn*10)/10;q('.shsf-cunit').textContent='in';}
    else{q('.shsf-cval').textContent=Math.round(state.chestIn*2.54);q('.shsf-cunit').textContent='cm';}
    q('.shsf-crange').value=state.chestIn;
    if(state.waistUnit==='in'){q('.shsf-wval').textContent=Math.round(state.waistIn*10)/10;q('.shsf-wunit').textContent='in';}
    else{q('.shsf-wval').textContent=Math.round(state.waistIn*2.54);q('.shsf-wunit').textContent='cm';}
    q('.shsf-wrange').value=state.waistIn;
  }

  function modalHTML(){
    return '<div class="shsf-bg" data-shsf-close></div>'
    +'<div class="shsf-card" role="dialog" aria-label="Find your size">'
    +'<button class="shsf-close" data-shsf-close aria-label="Close">&times;</button>'
    +'<button class="shsf-back" aria-label="Back">&lsaquo;</button>'
    +'<div class="shsf-head"><h2>Find your size</h2><p class="shsf-sub"></p></div>'
    +'<div class="shsf-body">'
    +field('Your chest','c','chest','Measure around the fullest part of your chest, under the arms.')
    +field('Your waist','w','waist','Measure around the fullest part of your belly — tape level and relaxed. Don\'t breathe in or pull it tight.')
    +'<div class="shsf-field"><div class="shsf-labelrow"><span class="shsf-label">Your height</span>'
      +'<div class="shsf-seg shsf-seg-height"><button class="on" data-u="ft">FT / IN</button><button data-u="cm">CM</button></div></div>'
      +'<div class="shsf-selects shsf-ftwrap"><select class="shsf-htsel"></select></div>'
      +'<div class="shsf-hidden shsf-cmwrap"><input class="shsf-cm shsf-cminput" type="number" value="178" min="130" max="220"></div></div>'
    +'<button type="button" class="shsf-confirm">Confirm my measurements</button>'
    +'</div>'
    +'<div class="shsf-result">'
    +'<div class="shsf-rlabel">Suggested size<span class="shsf-rlabel-sub">with or without armour</span></div><div class="shsf-rsize"></div><div class="shsf-rdetail"></div>'
    +'<div class="shsf-labelrow shsf-fitlabelrow"><span class="shsf-label">How you like it to fit</span></div>'
    +'<div class="shsf-pills shsf-fitpills">'
      +'<div class="shsf-pill" data-v="snug">Snug<small>close to body</small></div>'
      +'<div class="shsf-pill on" data-v="true">True<small>as designed</small></div>'
      +'<div class="shsf-pill" data-v="layer">Room<small>to layer</small></div></div>'
    +'<div class="shsf-rmain"></div><div class="shsf-rsub"></div>'
    +'<div class="shsf-fitpanel"><div class="shsf-fitbars"></div><div class="shsf-neighbours"></div></div>'
    +'<button type="button" class="shsf-cta shsf-toshop">Shop my size</button>'
    +'<div class="shsf-capture" style="display:none">'
      +'<div class="shsf-caplead"></div>'
      +'<input type="email" class="shsf-email" inputmode="email" autocomplete="email" placeholder="you@email.com">'
      +'<label class="shsf-consent"><input type="checkbox" class="shsf-optin">Tick if you\'d like to receive our newsletter</label>'
      +'<button type="button" class="shsf-cta shsf-rescue">Send my details</button>'
      +'<div class="shsf-capmsg"></div>'
    +'</div>'
    +'</div>'
    +'<div class="shsf-save" style="display:none">'
      +'<div class="shsf-savetitle">Want us to remember your size?</div>'
      +'<div class="shsf-savesub">We\'ll remember your <b class="shsf-savesize"></b>, making browsing quicker and easier.</div>'
      +'<ul class="shsf-benefits">'
        +'<li>Your size preselected on every jacket &mdash; browse and check out faster</li>'
        +'<li>One tap to see the styles in stock in your size</li>'
        +'<li>Helps us recommend jackets in your size as new styles land</li>'
      +'</ul>'
      +'<input type="email" class="shsf-email2" inputmode="email" autocomplete="email" placeholder="you@email.com">'
      +'<label class="shsf-consent"><input type="checkbox" class="shsf-optin2">Tick to receive our newsletter (new products, restocks, offers)</label>'
      +'<div class="shsf-privacy">No spam, unsubscribe anytime.</div>'
      +'<button type="button" class="shsf-cta shsf-savecta">Save my size</button>'
      +'<button type="button" class="shsf-skip">No thanks, shop my size</button>'
      +'<div class="shsf-capmsg2"></div>'
    +'</div>'
    +'<div class="shsf-foot"><div class="g">A guide, not a guarantee.</div>'
    +'<div class="c">Still unsure? Get in touch:<br><a href="mailto:support@goldtop.co.uk">support@goldtop.co.uk</a><br><span class="shsf-nowrap">+44 (0)208 088 4840</span></div></div>'
    +'</div>';
  }
  function field(label,pfx,unitTarget,hint){
    return '<div class="shsf-field"><div class="shsf-labelrow"><span class="shsf-label">'+label+'</span>'
      +'<div class="shsf-seg shsf-seg-'+unitTarget+'"><button class="on" data-u="in">INCHES</button><button data-u="cm">CM</button></div></div>'
      +'<div class="shsf-stepper"><button class="shsf-step shsf-'+pfx+'minus">&minus;</button>'
      +'<div class="shsf-value"><span class="shsf-'+pfx+'val">40</span><small class="shsf-'+pfx+'unit">in</small></div>'
      +'<button class="shsf-step shsf-'+pfx+'plus">+</button></div>'
      +'<input type="range" class="shsf-'+pfx+'range" min="26" max="58" step="0.5" value="40">'
      +'<div class="shsf-hint">'+hint+'</div></div>';
  }

  function showStep(n){
    state.step=n;
    var body=q('.shsf-body'),result=q('.shsf-result'),save=q('.shsf-save'),back=q('.shsf-back');
    if(back) back.style.display=(n>=2)?'flex':'none';
    body.style.display=(n===1)?'':'none';
    result.style.display=(n===2)?'':'none';
    if(save) save.style.display=(n===3)?'':'none';
    var head=q('.shsf-head'); if(head) head.style.display=(n===3)?'none':'';
    if(n===2){
      state.reachedResult=true;
      render(true);
      if(!state.resultFired){
        try{ var ri=resultInfo(); track('size_finder_result',ri); stampCart(ri,chosenSizeNow()); }catch(e){}
        state.resultFired=true;
      }
      rememberSize(chosenSizeNow());
    } else if(n===3){
      var r3=recommend(); var sz3=viewSize||r3.size; var szTxt=(sz3?sz3+'″':'your size');
      var loggedIn=!!(cfg&&cfg.cid);
      var t3=q('.shsf-savetitle'),sub3=q('.shsf-savesub'),em3=q('.shsf-email2'),pv3=q('.shsf-privacy'),sc3=q('.shsf-savecta'),sk3=q('.shsf-skip');
      if(loggedIn){
        if(t3) t3.textContent='Your size is saved to your account';
        if(sub3) sub3.innerHTML='We\'ll preselect <b>'+szTxt+'</b> for you wherever you shop.';
        if(em3) em3.style.display='none';
        if(pv3) pv3.style.display='none';
        if(sc3) sc3.textContent='Done';
        if(sk3) sk3.style.display='none';
      } else {
        if(t3) t3.textContent='Want us to remember your size?';
        if(sub3) sub3.innerHTML='We\'ll remember your <b class="shsf-savesize">'+szTxt+'</b>, making browsing quicker and easier.';
        if(em3){ em3.style.display=''; if(cfg.email&&!em3.value) em3.value=cfg.email; }
        if(pv3) pv3.style.display='';
        if(sc3) sc3.textContent='Save my size';
        if(sk3) sk3.style.display='';
      }
      try{ track('size_finder_save_view',resultInfo()); }catch(e){}
    }
    var card=q('.shsf-card'); if(card) card.scrollTop=0;
  }

  var EMAIL_RE=/.+@.+\..+/;
  // out-of-range rescue: email required
  function submitCapture(){
    var emailEl=q('.shsf-email'),email=emailEl?emailEl.value.trim():'';
    var consent=q('.shsf-optin')&&q('.shsf-optin').checked;
    var msg=q('.shsf-capmsg');
    if(!EMAIL_RE.test(email)){ if(msg) msg.textContent='Add your email above so we can help with your fit.'; return; }
    var info=resultInfo();
    info.capture_email=email; info.consent=consent?'yes':'no'; info.has_email='yes'; info.cta='rescue'; info.size_chosen='out_of_range';
    capturePost(info);
    if(msg) msg.textContent='Thanks — your details are saved.';
    setTimeout(close,900);
  }
  // step 3 save: optional email, benefit-led
  function saveSubmit(){
    var consent=q('.shsf-optin2')&&q('.shsf-optin2').checked;
    var msg=q('.shsf-capmsg2');
    var r=recommend(); var sz=viewSize||r.size;
    if(cfg&&cfg.cid){                              // logged in: size already on their account
      var infoM=resultInfo();
      infoM.capture_email=cfg.email||''; infoM.consent=consent?'yes':'no'; infoM.has_email=cfg.email?'yes':'no'; infoM.cta='save_member'; infoM.size_chosen=sz;
      capturePost(infoM);
      try{ stampCart(infoM,sz); }catch(e){}
      close(); return;
    }
    var emailEl=q('.shsf-email2'),email=emailEl?emailEl.value.trim():'';
    if(!EMAIL_RE.test(email)){ if(msg) msg.textContent='Pop your email in to save your size.'; return; }
    var info=resultInfo();
    info.capture_email=email; info.consent=consent?'yes':'no'; info.has_email='yes'; info.cta='save'; info.size_chosen=sz;
    capturePost(info);
    try{ stampCart(info,sz); }catch(e){}
    if(msg) msg.textContent='Saved — taking you to your size…';
    setTimeout(close,700);
  }
  // step 3 skip: proceed to the jacket, no email
  function skipSave(){
    var r=recommend(); var sz=viewSize||r.size;
    var info=resultInfo();
    info.capture_email=''; info.consent='no'; info.has_email='no'; info.cta='skip'; info.size_chosen=sz;
    capturePost(info);
    try{ stampCart(info,sz); }catch(e){}
    close();
  }

  function wire(){
    // chest + waist steppers/sliders
    wireMeasure('chestIn','c',26,58); wireMeasure('waistIn','w',26,58);
    // height — one combined ft/in dropdown (single control, so no cross-field race)
    var htsel=q('.shsf-htsel');
    for(var hi=48;hi<=84;hi++){var o=document.createElement('option');o.value=hi;o.textContent=Math.floor(hi/12)+"' "+(hi%12)+'"';if(hi===70)o.selected=true;htsel.appendChild(o);}
    htsel.addEventListener('change',function(){var v=parseInt(htsel.value,10);if(!isNaN(v)){state.heightIn=v;render();}});
    q('.shsf-cminput').addEventListener('input',function(){state.heightIn=(parseFloat(this.value)||178)/2.54;render();});
    // unit toggles
    root.querySelectorAll('.shsf-seg').forEach(function(seg){
      seg.addEventListener('click',function(e){
        var b=e.target.closest('button'); if(!b)return;
        seg.querySelectorAll('button').forEach(function(x){x.classList.remove('on');}); b.classList.add('on');
        var u=b.getAttribute('data-u');
        if(seg.classList.contains('shsf-seg-chest')){state.chestUnit=u;state.chestIn=snapToUnit(state.chestIn,u);render();}
        else if(seg.classList.contains('shsf-seg-waist')){state.waistUnit=u;state.waistIn=snapToUnit(state.waistIn,u);render();}
        else if(seg.classList.contains('shsf-seg-height')){
          state.heightUnit=u;
          if(u==='cm'){q('.shsf-ftwrap').classList.add('shsf-hidden');q('.shsf-cmwrap').classList.remove('shsf-hidden');q('.shsf-cminput').value=Math.round(state.heightIn*2.54);}
          else{q('.shsf-cmwrap').classList.add('shsf-hidden');q('.shsf-ftwrap').classList.remove('shsf-hidden');var t=clamp(Math.round(state.heightIn),48,84);q('.shsf-htsel').value=t;}
        }
      });
    });
    // fit pills (now on the result step)
    var fp=q('.shsf-fitpills');
    fp.addEventListener('click',function(e){var p=e.target.closest('.shsf-pill');if(!p)return;
      fp.querySelectorAll('.shsf-pill').forEach(function(x){x.classList.remove('on');});p.classList.add('on');state.fit=p.getAttribute('data-v');render();});
    // step navigation + capture
    q('.shsf-confirm').addEventListener('click',function(){showStep(2);});
    var back=q('.shsf-back'); if(back) back.addEventListener('click',function(e){e.preventDefault(); if(state){ if(state.step===3){ showStep(2); } else { state.edits++; showStep(1); } }});
    q('.shsf-toshop').addEventListener('click',function(){showStep(3);});
    var rescueBtn=q('.shsf-rescue'); if(rescueBtn) rescueBtn.addEventListener('click',submitCapture);
    var saveBtn=q('.shsf-savecta'); if(saveBtn) saveBtn.addEventListener('click',saveSubmit);
    var skipBtn=q('.shsf-skip'); if(skipBtn) skipBtn.addEventListener('click',skipSave);
    // engagement flag -> drives the result event on confirm
    root.addEventListener('input',function(){if(state)state.touched=true;},true);
    root.addEventListener('change',function(){if(state){state.touched=true;state.adjustments++;}},true);
    root.addEventListener('click',function(e){if(!state)return;var el=e.target;
      if(el.closest('.shsf-step')){state.touched=true;state.adjustments++;}
      else if(el.closest('.shsf-pill')){state.touched=true;state.fitSwitches++;}
      else if(el.closest('.shsf-seg')){state.touched=true;state.unitSwitches++;}
      else if(el.closest('.shsf-nb')){state.touched=true;state.sizesPreviewed++;}
    },true);
  }
  function snapToUnit(v,u){return u==='cm'?Math.round(v*2.54)/2.54:Math.round(v*2)/2;}
  function stepM(key,uk,dir,lo,hi){
    if(state[uk]==='cm'){var cm=Math.round(state[key]*2.54)+dir;state[key]=clamp(cm/2.54,lo,hi);}
    else{var inch=Math.round(state[key]*2)/2+dir*0.5;state[key]=clamp(inch,lo,hi);}
    render();
  }
  function wireMeasure(key,pfx,lo,hi){
    var uk=key.replace('In','Unit');
    q('.shsf-'+pfx+'range').addEventListener('input',function(){state[key]=clamp(snapToUnit(parseFloat(this.value),state[uk]),lo,hi);render();});
    q('.shsf-'+pfx+'minus').addEventListener('click',function(){stepM(key,uk,-1,lo,hi);});
    q('.shsf-'+pfx+'plus').addEventListener('click',function(){stepM(key,uk,1,lo,hi);});
  }

  function open(config){
    if(root){root.remove();root=null;}
    cfg={name:(config.name||'').trim(),fit:(config.fit||'').trim(),logo:config.logo||'',handle:config.handle||'',price:config.price||'',email:config.email||'',cid:config.cid||''};
    track('size_finder_open',prodInfo());
    state={chestIn:40,waistIn:34,heightIn:70,fit:'true',chestUnit:'in',waistUnit:'in',heightUnit:'ft',touched:false,openedAt:Date.now(),adjustments:0,unitSwitches:0,fitSwitches:0,sizesPreviewed:0,everOOR:false,step:1,reachedResult:false,resultFired:false,edits:0};
    viewSize=null;
    root=document.createElement('div'); root.id='shsf-root'; root.innerHTML=modalHTML();
    document.body.appendChild(root);
    q('.shsf-sub').textContent=cfg.name||'';
    wire(); render(); showStep(1);
    requestAnimationFrame(function(){root.classList.add('open');});
    document.documentElement.style.overflow='hidden';
  }
  function close(){ if(!root)return;
    var applyInstock=false;
    try{ applyInstock=!!sessionStorage.getItem('shsf_applyInstock'); if(applyInstock) sessionStorage.removeItem('shsf_applyInstock'); }catch(e){}
    var cs='';
    try{ if(state&&state.reachedResult){ cs=chosenSizeNow(); if(cs){ preselectSize(cs); rememberSize(cs); } } }catch(e){}
    if(applyInstock&&cs){ document.documentElement.style.overflow=''; location.href=location.pathname+'?filter.v.availability=1&filter.v.option.size='+encodeURIComponent(cs+'"'); return; }
    root.classList.remove('open'); document.documentElement.style.overflow='';
    var el=root; setTimeout(function(){if(el&&el.parentNode)el.remove(); if(root===el)root=null;},150); }

  document.addEventListener('click',function(e){
    var t=e.target.closest('[data-shsf-open]');
    if(t){e.preventDefault();
      open({name:t.getAttribute('data-product-name'),fit:t.getAttribute('data-fit'),logo:t.getAttribute('data-logo'),handle:t.getAttribute('data-product-handle'),price:t.getAttribute('data-product-price'),email:t.getAttribute('data-customer-email'),cid:t.getAttribute('data-customer-id')});
      return;}
    if(e.target.closest('[data-shsf-close]')) close();
  });
  document.addEventListener('keydown',function(e){if(e.key==='Escape')close();});
})();
